import { Box, VStack, Text, Heading } from '@chakra-ui/react';

type ModifierLabelProps = {
  isRequired?: boolean;
  isError?: boolean;
  title: string;
  description: string;
  isFullWidth?: boolean;
};

export default function ModifierLabel({
  isRequired = false,
  isError = false,
  title,
  description,
  isFullWidth,
}: ModifierLabelProps) {
  return (
    <Box
      position="sticky"
      top="130"
      zIndex="50"
      borderRadius="5px"
      p={2}
      mx={isFullWidth ? -4 : 0}
      bgColor={isError ? 'danger.200' : 'gray.100'}
    >
      <VStack align="flex-start" spacing={1}>
        <Heading size="xs" color={isError ? 'danger.600' : 'fontColor'}>
          {title}
          {isRequired && (
            <Text as="sup" color="red">
              &#8727;
            </Text>
          )}
        </Heading>
        <Text fontSize="xs" color={isError ? 'danger.600' : 'gray.500'}>
          {description}
        </Text>
      </VStack>
    </Box>
  );
}
